export default __webpack_public_path__ + "static/theloops-efa645195b57416a60e344680666c0ba.png";